import { IRuleOptions, IValidationOptions, IValidationRule, RuleName } from "./Validator";

export class ValidEmailRule implements IValidationRule
{
    public rule: RuleName = 'ValidEmail';
    private errorLabel: string;

    constructor(validationOptions: IValidationOptions, ruleOptions: IRuleOptions = {})
    {
        this.errorLabel = ruleOptions.errorLabel ?? validationOptions.mustBeValidEmailLabel ?? validationOptions.invalidFieldLabel;
    }

    public validate(value: string): string
    {
        // this is the same logic for email validation used in the back end
        // see System.ComponentModel.DataAnnotations.EmailAddressAttribute 
        const index = value.indexOf('@');

        if (index > 0 &&
            index !== value.length - 1 &&
            index === value.lastIndexOf('@'))
            return '';
        return this.errorLabel;
    }
}
